export default "__VITE_ASSET__CUdTLtkj__"